// Copyright (c) 2025-2026 One Great World LLC. All rights reserved.

import './SlideStyles.css'

function NextStepsSlide() {
  return (
    <div className="slide-content centered">
      <h1 className="slide-title">Next Steps</h1>
      <p className="slide-text large">
        Try tagging a file, finding it again, and leaving yourself a note
      </p>
      <p className="slide-text">
        Search for <strong>"Productivity Plus Pack"</strong> using the Windows Start menu.
        Open <strong>Welcome → Try these first</strong> to follow the checklist at your own pace.
      </p>
      <div style={{ display: 'flex', gap: '40px', alignItems: 'center', justifyContent: 'center', margin: '10px 0', maxWidth: '100%', flexWrap: 'wrap' }}>
        <img 
          src="./assets/Getting_Started_Next_Steps.png" 
          alt="Windows Start menu search showing Productivity Plus Pack" 
          className="screenshot-image" 
          style={{ maxWidth: 'min(450px, 45vw)', maxHeight: 'min(400px, 40vh)', width: 'auto', height: 'auto', objectFit: 'contain', border: '1px solid #ccc', borderRadius: '4px' }}
        />
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0 }}>
          <h2 className="slide-text large" style={{ fontSize: '1.75rem', fontWeight: 600, marginBottom: '1rem' }}>Happy Productivity!</h2>
          <img 
            src="./assets/mediakeys-icon.png" 
            alt="Philip says Hi!" 
            className="app-icon-large"
            style={{ width: '100px', height: '100px' }}
          />
        </div>
      </div>
      <p className="slide-text">
        What would you like to organize? Explore{' '}
        <a href="https://www.onegreatworld.com/products/productivity-plus-pack/Articles/#workflows" target="_blank" rel="noopener noreferrer">workflows for documents, family photos, client projects and research</a>.
      </p>
      <div className="slide-footer">
        <div className="footer-brand">Productivity Plus Pack</div>
        <div className="footer-copyright">© 2025-2026 One Great World LLC</div>
      </div>
    </div>
  )
}

export default NextStepsSlide
